import { render, staticRenderFns } from "./top-title.vue?vue&type=template&id=67a6a6c0&scoped=true"
import script from "./top-title.vue?vue&type=script&lang=js"
export * from "./top-title.vue?vue&type=script&lang=js"
import style0 from "./top-title.vue?vue&type=style&index=0&id=67a6a6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6a6c0",
  null
  
)

export default component.exports